export default __webpack_public_path__ + "static/media/s2a.b334d5b2.jpg";